
  <div class="row margin-bottom-10px">
    <div class="col-md-12">
      <!--

  Title                                         edit button
  ==========================================================
  text block, non editable..


  ==========================================================


      -->

      <div id="AddlNotes">
        <form class="form " novalidate="" #f="ngForm">
          <div class="accordion" id="accordionExampleThr">
            <div class="card margin-bottom-5px">
              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingThr">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="mb-0 height-24px">
                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseThr" aria-expanded="true" aria-controls="collapseThr">
                        Notes
                      </button>
                    </h5>
                  </div>
                  <div class="col-md-7 text-align-right">
                    <a class="nav-link-hand education-navlink" (click)="EditAdditionalInformation()" tooltip="Edit">
                      <span class="badge font-size-12px"><i class="fas fa-pencil-alt"></i></span>
                    </a>
                  </div>
                </div>


              </div>

              <div id="collapseThr" class="collapse show" aria-labelledby="headingThr" data-parent="#accordionExampleThr">
                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                  <div class="row padding-top-3px">
                    <div class="col-md-11 padding-right-0px margin-left-10px" *ngIf="CurrentNotes">
                      <textarea class="form-control3 size-2 width-inherit"
                                name="CurrentNotes.DataValue"
                                [(ngModel)]="CurrentNotes.DataValue"
                                rows="2" placeholder="Notes"></textarea>                      
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </form>
      </div>


    </div>

  </div>

